var render, staticRenderFns
import script from "./get-signed-url.vue?vue&type=script&lang=ts"
export * from "./get-signed-url.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768773b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('768773b7')) {
      api.createRecord('768773b7', component.options)
    } else {
      api.reload('768773b7', component.options)
    }
    
  }
}
component.options.__file = "src/shared/components/get-signed-url/get-signed-url.vue"
export default component.exports